import { styled } from 'naan/stitches.config';

export const LinkContainer = styled('span', {
  '& a': {
    textStyle: 'body',
    color: '$teal-500',
    textDecoration: 'underline',
  },
});
